function normalizeStoredValue(value)
{
    if (value === null || value === undefined || value === "undefined" || value === "null" || value === "")
        return null;
    return value;
}

function getStoredUser()
{
    const rawUser = normalizeStoredValue(localStorage.getItem('user'));
    if (!rawUser)
        return null;

    try {
        const parsedUser = JSON.parse(rawUser);
        if (!parsedUser || typeof parsedUser !== "object" || parsedUser.id === null || parsedUser.id === undefined)
        {
            localStorage.removeItem('user');
            localStorage.setItem('hasUser', 'false');
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('activeUserId');
            return null;
        }
        return parsedUser;
    } catch (_) {
        localStorage.removeItem('user');
        localStorage.setItem('hasUser', 'false');
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('activeUserId');
        return null;
    }
}

function setOrRemoveItem(key, value)
{
    if (value === null || value === undefined || value === "")
    {
        localStorage.removeItem(key);
        return;
    }
    localStorage.setItem(key, value);
}

export function GetAllLogin()
{
    const user = getStoredUser();
    var data = {
        access_token: normalizeStoredValue(localStorage.getItem('access_token')),
        refresh_token: normalizeStoredValue(localStorage.getItem('refresh_token')),
        user: user,
        activeUserId: normalizeStoredValue(localStorage.getItem('activeUserId'))
    }

    return data;
}

export async function SaveLogin(data)
{
    const hasValidUser = !!(data?.user && typeof data.user === "object" && data.user.id !== null && data.user.id !== undefined);
    localStorage.setItem('hasUser', hasValidUser ? 'true' : 'false');

    setOrRemoveItem('access_token', normalizeStoredValue(data?.access_token));
    setOrRemoveItem('refresh_token', normalizeStoredValue(data?.refresh_token));

    if (hasValidUser)
        localStorage.setItem('user', JSON.stringify(data.user));
    else
        localStorage.removeItem('user');

    const activeUserId = data?.activeUserId;
    const hasActiveUserId = activeUserId !== null && activeUserId !== undefined && activeUserId !== "";
    if (hasActiveUserId)
        localStorage.setItem('activeUserId', activeUserId);
    else
        localStorage.removeItem('activeUserId');
}

export async function DeleteLogin()
{
    localStorage.removeItem('hasUser');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    localStorage.removeItem('activeUserId');
}

export async function UpdateUser(userId)
{
    localStorage.setItem('activeUserId', userId);
}
